import { render, staticRenderFns } from "./modal_excluir_prescricao.vue?vue&type=template&id=17bc2391&scoped=true"
import script from "./modal_excluir_prescricao.vue?vue&type=script&lang=js"
export * from "./modal_excluir_prescricao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bc2391",
  null
  
)

export default component.exports